import { formatDateDDMMMYYYY } from './dateFormat';
import { buildLetterFooterSignOff } from './letterSignOffFormat';
import { VISIT_TYPES } from './constants';

const getVisitTypeLabel = (visitType) => {
  const code = (visitType ?? '').toString().trim().toUpperCase();
  return VISIT_TYPES[code] || visitType || '';
};

export function buildLetterContextFromVisit(visitDetail, authUser) {
  const d = visitDetail || {};
  const piName = d.piName ?? d.PIName ?? '';
  const projectCode = d.projectCode ?? d.ProjectCode ?? '';
  const projectDescription = d.projectDescription ?? d.ProjectDescription ?? '';
  const siteCode = d.siteCode ?? d.SiteCode ?? '';
  const siteName = d.siteName ?? d.SiteName ?? '';
  const letterSiteAddress = d.letterSiteAddress ?? d.LetterSiteAddress ?? '';
  const siteAddress = letterSiteAddress || siteName;
  const visitType = d.visitType ?? d.VisitType ?? '';
  const visitDateRaw = d.plannedStartDate ?? d.PlannedStartDate;
  const craName = (d.craName ?? d.CRAName ?? '').toString().trim();
  const craEmail = d.craEmail ?? d.CraEmail ?? authUser?.email ?? authUser?.Email ?? authUser?.vEmailId ?? '';
  const signOff = buildLetterFooterSignOff(authUser) || craName;
  const today = formatDateDDMMMYYYY(new Date());
  const visitDate = visitDateRaw ? formatDateDDMMMYYYY(visitDateRaw) : '';

  return {
    '{{Date}}': today,
    '{{LetterDate}}': today,
    '{{PIName}}': piName,
    '{{SiteName}}': siteName,
    '{{SiteCode}}': siteCode,
    '{{SiteAddress}}': siteAddress,
    '{{ProtocolNo}}': projectCode,
    '{{ProjectTitle}}': projectDescription,
    '{{StudyReference}}': projectCode,
    '{{VisitDate}}': visitDate,
    '{{VisitType}}': visitType,
    '{{VisitTypeLabel}}': getVisitTypeLabel(visitType),
    '{{CRASignOff}}': signOff,
    '{{CRAEmail}}': craEmail,
  };
}

export function substituteLetterPlaceholders(text, context) {
  if (!text) return '';
  let result = String(text);
  Object.entries(context || {}).forEach(([token, value]) => {
    result = result.split(token).join(value ?? '');
  });
  return result;
}

export function plainTextToLetterBodyHtml(text) {
  if (!text) return '';
  const trimmed = String(text).trim();
  if (!trimmed) return '';
  if (/<[a-z][\s\S]*>/i.test(trimmed)) return trimmed;
  return trimmed.replace(/\n/g, '<br />');
}

export function buildLetterPartsFromTemplate(template, visitDetail, authUser) {
  const ctx = buildLetterContextFromVisit(visitDetail, authUser);
  const header = template?.headerTemplate ?? template?.HeaderTemplate ?? '';
  const body = template?.bodyTemplate ?? template?.BodyTemplate ?? '';
  const footer = template?.footerTemplate ?? template?.FooterTemplate ?? '';
  return {
    headerText: substituteLetterPlaceholders(header, ctx),
    bodyHtml: plainTextToLetterBodyHtml(substituteLetterPlaceholders(body, ctx)),
    footerText: substituteLetterPlaceholders(footer, ctx),
  };
}
